document.addEventListener('DOMContentLoaded', () => {
  const cards = document.querySelectorAll('.featured-card[data-animate]');
  cards.forEach((card, index) => {
    setTimeout(() => {
      card.classList.add('is-visible');
    }, index * 120);
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const explore = document.querySelector('[data-explore]');
  if (!explore) return;

  const toggle = explore.querySelector('[data-explore-toggle]');
  const tags = explore.querySelector('[data-explore-tags]');

  let collapsed = true;
  explore.dataset.collapsed = collapsed;

  toggle.addEventListener('click', () => {
    collapsed = !collapsed;
    explore.dataset.collapsed = collapsed;
    toggle.textContent = collapsed ? 'More' : 'Less';
    toggle.setAttribute('aria-expanded', !collapsed);
  });
});

document.addEventListener('click', e => {
  const toggle = e.target.closest('.blog-explore__toggle');
  if (!toggle) return;

  const bar = toggle.closest('.blog-explore');
  const expanded = bar.dataset.collapsed === 'false';

  bar.dataset.collapsed = expanded ? 'true' : 'false';
  toggle.textContent = expanded ? 'More' : 'Less';
  toggle.setAttribute('aria-expanded', String(!expanded));
});


document.addEventListener("DOMContentLoaded", () => {
  const cards = document.querySelectorAll(".featured-card--glass");

  cards.forEach(card => {
    const img = card.querySelector("img");
    if (!img) return;

    // Ensure image is loaded
    if (!img.complete) {
      img.onload = () => analyzeImage(card, img);
    } else {
      analyzeImage(card, img);
    }
  });

  function analyzeImage(card, img) {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    const width = canvas.width = 40;
    const height = canvas.height = 40;

    ctx.drawImage(
  img,
  0,
  img.naturalHeight * 0.6,
  img.naturalWidth,
  img.naturalHeight * 0.4,
  0,
  0,
  width,
  height
);


    const imageData = ctx.getImageData(0, 0, width, height).data;

    let brightness = 0;
    for (let i = 0; i < imageData.length; i += 4) {
      // perceived luminance formula
      brightness +=
        imageData[i] * 0.299 +
        imageData[i + 1] * 0.587 +
        imageData[i + 2] * 0.114;
    }

    brightness /= (imageData.length / 4);

   if (brightness > 185) {
  card.classList.add("is-very-light-image");
} else if (brightness > 140) {
  card.classList.add("is-light-image");
} else {
  card.classList.add("is-dark-image");
}
  }
});


document.addEventListener('click', (e) => {
  const toggle = e.target.closest('[data-dropdown-toggle]');
  if (!toggle) return;

  e.preventDefault();
  e.stopPropagation();

  const expanded = toggle.getAttribute('aria-expanded') === 'true';
  toggle.setAttribute('aria-expanded', String(!expanded));

  toggle.closest('[data-dropdown]')
    ?.setAttribute('data-open', String(!expanded));
});
